module.exports = window["Wistia"]["Preact"]["compat"];